import React, {createContext} from 'react';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';

export const ErrorContext = createContext();

const ErrorContextProvider = (props) => {
    let history = useHistory();

    const handleErrors = (errObj, setError, callback) => {
        let code = errObj ? errObj.code : undefined;
        switch(code) {
            case 'INTERNAL_ERROR':
                toast.error('Unable to complete your request at this time');
                break;
            case 'LOGICAL_ERROR':
                errObj.message && toast.error(errObj.message);
                break;
            case 'ACCESS_DENIED':
                localStorage.removeItem('token');
                history.push('/signin');
                break;
            case 'AUTHENTICATION_FAILED':
                localStorage.removeItem('token');
                history.push('/signin');
                break;
            case 'VALIDATION_FAILED':
                setError && setError(errObj.errors);
                break;
            case 'NOT_FOUND':
                history.push('/404');
                break;
            case 'ACCOUNT_IS_SUSPENDED':
                history.push('/suspended/request');
                break;
            case 'USERNAME_INVALID':
                toast.error('The email or password did not match our records. Please try again.');
                break;
            case 'PASSWORD_INVALID':
                toast.error('The email or password did not match our records. Please try again.');
                break;
            default:
                toast.error('Unable to complete your request at this time');
        }
        callback && callback();
    }

    return (
        <ErrorContext.Provider value={{
           handleErrors
        }}>
            {props.children}
        </ErrorContext.Provider>
    );
};

export default ErrorContextProvider;